











































import { Vue, Component, Prop } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';

import { AlertasBaseBackend } from '@/pantallas/ConfigurarBase/ConfiguracionBase';
import SeleccionarCodigosForm from '@/pantallas/ConfigurarBase/SeleccionarCodigosForm.vue';
import AgregarCamposGrid from '@/pantallas/ConfigurarBase/AgregarCamposGrid.vue';
import ValidacionExtendidaForm from '@/pantallas/ConfigurarBase/ValidacionExtendidaForm.vue';
import HtmlTemplateForm from '@/pantallas/ConfigurarBase/HtmlTemplateForm.vue';

import { makeAlertasBaseVerDetalle } from '@/pantallas/ConfigurarBase/ConfiguracionBase';
import { OperacionCrud } from '@/reusable/Mantenedor/OperacionCrud';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    SeleccionarCodigosForm,
    AgregarCamposGrid,
    ValidacionExtendidaForm,
    HtmlTemplateForm,
  },
})
export default class VerAlertaBaseModal extends OperacionCrud {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: null }) alertaBaseSeleccionada: AlertasBaseBackend | void;

  funcionalidad: Funcionalidades = Funcionalidades.AlertasBase;
  pasoActivoIndex: number = 1;

  readonly pasos: PasosCrud = makeAlertasBaseVerDetalle();

  /* event handlers */

  handleCerrar() {
    this.pasoActivoIndex = 1;
    this.$emit('cerrar');
  }
}
